import useAuth from "hooks/useAuth";
import { Navigate } from "react-router";
import { getAppDefaultPath } from 'config';

export default function ProtectedComponent({ routeId, allowedRoles, children }) {
  const { isLoggedIn, user, roles = [], isAdmin, canAccess } = useAuth();
  const path = getAppDefaultPath(user);

  if (!isLoggedIn) {
    return <Navigate to="login"></Navigate>;
  }
  if (allowedRoles?.length && !isAdmin && !allowedRoles.some((role) => roles.includes(role))) {
    return <Navigate to={path}></Navigate>;
  }
  if (routeId && canAccess(routeId)) {
    return children;
  }
  return <Navigate to={path}></Navigate>;
}
